export default "__VITE_ASSET__b5d7c98e__"